export const environment = {
    production: true,
    BaseUrlBE: 'https://gp.besidetech.it/api/',
    UsersBaseUrl: 'https://gp.besidetech.it/api/users',
    TemplateBaseUrl: 'https://gp.besidetech.it/api/template',
    CustomersBaseUrl: 'https://gp.besidetech.it/api/customers',
    GiuridicTypeBaseUrl: 'https://gp.besidetech.it/api/giuridictype',
    PaymentMethodBaseUrl: 'https://gp.besidetech.it/api/paymentMethod',
    PreventiviMethodBaseUrl: 'https://gp.besidetech.it/api/preventivo',
    PrezzoImballoMethodBaseUrl: "https://gp.besidetech.it/api/prezzoImballo",
    CopiaLavorazioneMethodBaseUrl: 'https://gp.besidetech.it/api/copia_lavorazione',
    ClausolePreventivoUrl: 'https://gp.besidetech.it/api/clausolepreventivo',
    SistemiDiPagamentoUrl: 'https://gp.besidetech.it/api/coordinatebancarie',
    CaricoVirtualeMethodBaseUrl: 'https://gp.besidetech.it/api/carico_virtuale',
    PercentualiMethodBaseUrl: 'https://gp.besidetech.it/api/percentuali',
    CambioPrezzoMethodBaseUrl: "https://gp.besidetech.it/api/cambio-prezzi",
    ordineBaseUrl: 'https://gp.besidetech.it/api/ordine',
    baseUrl: 'https://gp.besidetech.it',
    loginUrl: 'https://gp.besidetech.it/login',
    keycloakUrl: 'https://gp.besidetech.it/auth',
    wsUrl: 'https://gp.besidetech.it/api/ws',
    apiUrl: 'https://gp.besidetech.it/api/api/'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
